var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99917 13.1668H6.2125C5.43917 13.1668 4.76583 12.7002 4.49917 11.9802C4.22583 11.2602 4.42583 10.4668 5.00583 9.9535L10.3325 5.2935C10.6525 5.0135 10.6592 4.6335 10.5658 4.3735C10.4658 4.1135 10.2125 3.8335 9.78583 3.8335H7.99917C7.72583 3.8335 7.49917 3.60683 7.49917 3.3335C7.49917 3.06016 7.72583 2.8335 7.99917 2.8335H9.78583C10.5592 2.8335 11.2325 3.30016 11.4992 4.02016C11.7725 4.74016 11.5725 5.5335 10.9925 6.04683L5.66583 10.7068C5.34583 10.9868 5.33917 11.3668 5.4325 11.6268C5.5325 11.8868 5.78583 12.1668 6.2125 12.1668H7.99917C8.2725 12.1668 8.49917 12.3935 8.49917 12.6668C8.49917 12.9402 8.2725 13.1668 7.99917 13.1668Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3325 10H11.3325C10.5992 10 9.99917 10.6 9.99917 11.3333V13.3333C9.99917 14.0667 10.5992 14.6667 11.3325 14.6667H13.3325C14.0658 14.6667 14.6658 14.0667 14.6658 13.3333V11.3333C14.6658 10.6 14.0658 10 13.3325 10ZM12.3392 13C11.9725 13 11.6725 12.7 11.6725 12.3333C11.6725 11.9667 11.9658 11.6667 12.3392 11.6667H12.3458C12.7125 11.6667 13.0125 11.9667 13.0125 12.3333C13.0125 12.7 12.7125 13 12.3392 13Z",
    fill: "#717680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64583 1.3335C2.35917 1.3335 1.3125 2.38016 1.3125 3.66683C1.3125 4.9535 2.35917 6.00016 3.64583 6.00016C4.9325 6.00016 5.97917 4.9535 5.97917 3.66683C5.97917 2.38016 4.93917 1.3335 3.64583 1.3335ZM3.6725 4.3335C3.30583 4.3335 3.00583 4.0335 3.00583 3.66683C3.00583 3.30016 3.29917 3.00016 3.6725 3.00016H3.67917C4.04583 3.00016 4.34583 3.30016 4.34583 3.66683C4.34583 4.0335 4.04583 4.3335 3.6725 4.3335Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting2);
export default __webpack_public_path__ + "static/media/routing-2.2772e5b01a10c91f3360d5c09f18747f.svg";
export { ForwardRef as ReactComponent };